import styled from "styled-components";
import iconExternalLink from "../../../../../images/icon-external-link.svg";
import React, {useCallback} from "react";
import {log} from "../../../../logging/logEvent";

const PortfolioNameContainer = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
`;

const PortfolioCompanyName = styled.div`
    flex-grow: 0;
    flex-shrink: 0;
    color: #4a4a4a;
    font-size: 14px;
`;

const PortfolioName = styled.div`
    font-weight: bold;
    font-size: 26px;
`;

const PortfolioExternalLink = styled.a`
  text-decoration: none;
  color: #4a4a4a;
  background-image: url(${iconExternalLink});
  background-position: right;
  background-repeat: no-repeat;
  padding-right: 32px;
`;

export const NameOrLink = ({portfolioId, name, link}) => {
    const logExternalLinkTaken = useCallback(e => {
        log("PortfolioExternalLinkVisited", {portfolioId, name, link});
    }, [portfolioId, name, link]);

    if (!link)
        return name;

    return <PortfolioExternalLink target="_blank" href={link} onClick={logExternalLinkTaken}>{name}</PortfolioExternalLink>;
};

export const PortfolioDetails = ({portfolioAuthor: { portfolioId, portfolioCompanyName: companyName, portfolioName: name, portfolioExternalLink: externalLink }}) => (
    <PortfolioNameContainer>
        <PortfolioCompanyName className="t-portfolio-company-name">
            {companyName}
        </PortfolioCompanyName>
        <PortfolioName className="t-portfolio-name">
            <NameOrLink portfolioId={portfolioId} name={name} link={externalLink} />
        </PortfolioName>
    </PortfolioNameContainer>
);
